import React from "react";
import { makeStyles, Theme, createStyles, withStyles } from "@material-ui/core";

export const TwoPane = ({ children, ...props }: { children: React.ReactNode }) => {
  const classes = useStyles(props);
  return <div className={classes.root}>{children}</div>;
};

const Level = ({ left, right, ...props }: { left: React.ReactNode; right: React.ReactNode }) => {
  const classes = useStyles(props);
  return (
    <div className={classes.level}>
      <div className={classes.left}>{left}</div>
      <div className={classes.right}>{right}</div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "calc(100vh - 80px)",
      display: "flex",
      flexDirection: "column",
    },
    level: {
      display: "flex",
    },
    left: {
      flex: "0 0 368px",
      overflowX: "hidden",
      overflowY: "auto",
    },
    right: {
      border: "none",
      borderLeft: `1px solid ${theme.palette.ice.main}`,
      flex: "1 1",
      overflowX: "hidden",
      overflowY: "auto",
    },
  }),
);

const Header = withStyles((theme: Theme) => ({
  level: {
    flex: "0 0 81px",
    border: "none",
    borderBottom: `1px solid ${theme.palette.ice.main}`,
  },
  left: {
    display: "flex",
    alignItems: "center",
    padding: `${theme.spacing(2)}px`,
  },
  right: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: `${theme.spacing(2)}px`,
  },
}))(Level);

const Content = withStyles(() => ({
  level: {
    flex: "1 1 auto",
    height: "0",
    backgroundColor: "white",
  },
}))(Level);

TwoPane.Header = Header;
TwoPane.Content = Content;
